/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Timecode_OutInputs */



/**
* | output |
* | --- |
* | "Timecode Out" |
*
* @param {Ccsl_Export_Header_Timecode_OutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_timecode_out = /** @type {((inputs?: Ccsl_Export_Header_Timecode_OutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Timecode_OutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Timecode sortie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Timecode Out")
	if (locale === "it") return /** @type {LocalizedString} */ ("Uscita timecode")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Таймкод отсутствует")
	if (locale === "es") return /** @type {LocalizedString} */ ("Salida de código de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间码输出")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコード出力")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड आउट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Saída de código de tempo")
	return /** @type {LocalizedString} */ ("Timecode Out")
});